import api from './api';

export const subjectsAPI = {
  getAllSubjects: () => api.get(`/subjects/get-all-subjects`),
}